// @vendors
const get = require('lodash/object/get');
const Immutable = require('immutable');
const momentTz = require('moment-timezone');

// @actions
const signaturePatternActions = require('actions/signaturePattern');
const errorActions = require('actions/brokerError');
const { outdateGlobalPosition } = require('actions/myGlobalPosition');
const { outdateMyInvestments } = require('actions/brokerMyInvestments');
const brokerIntervenerActions = require('actions/brokerInterveners');
const { brokerStocksOperationFailure } = require('actions/brokerStocksOperationFailure');

// @helpers
const apiURLBuilder = require('../core/apiURLBuilder');
const { APIPost, APIGet } = require('utilities/APIRequestHelper');
const mifidErrorHelper = require('mifid/utilities/mifidErrorHelper');
const { getCCOfficeChannel } = require('utilities/contactCenter/printerHelper');
const translateExantCostKey = require('utilities/translationExantCost');

// @constants
const actionTypes = require('constants/actionTypes');

// @utils
const PersonalDataHelper = require('utilities/personalDataHelper');

const {
    CHARGE_ACCOUNT_PREFIX,
    WIZARD_FIRST_STEP,
    WIZARD_SECOND_STEP,
    FIRST_STEP,
    SECOND_STEP,
    FOR_THE_BEST_CODE,
    LIMITED_CODE,
    TO_MARKET_CODE,
    EURO_TEXT,
    BROKER_ORDER_TYPE_LIMITED,
    BROKER_ORDER_TYPE_FOR_THE_BEST,
    BROKER_ORDER_TYPE_TO_MARKET,
    BROKER_ORDER_TYPE_FOR_THE_BEST_DESCRIPTION,
    BROKER_ORDER_TYPE_LIMITED_DESCRIPTION,
    BROKER_ORDER_TYPE_TO_MARKET_DESCRIPTION,
    BROKER_STOCKS_BUY_NO_RESTRICTION,
    BROKER_CATEGORY_WARRANT,
    CONNECTION_CHANNEL_INTRANET,
    BROKER_CONVENIENCE_MIFID_TEST_WARRANTS_ID,
    BROKER_ORDER_TYPE_SELL,
    BROKER_DOCUMENT_TYPE,
    INTERVENER_TYPE_PROPIETARIO,
    CONNECTION_CHANNEL_INTERNET,
    BROKER_PRODUCT_TYPE_WARRANTS,
    DATE_FORMAT_WITH_DASHES_DATETIME,
    API_CHANNEL
} = require('constants/index');

const { WARRANTS_SELL_SHOW_COST } = require('constants/flagBasedFeatures');

function reset() {
    return {
        type: actionTypes.BROKER_WARRANTS_SELL_RESET
    };
}

function setVisibleStep(step) {
    return {
        type: actionTypes.BROKER_WARRANTS_SELL_SET_VISIBLE_STEP,
        payload: {
            step
        }
    };
}

function setWillCancel(value) {
    return {
        type: actionTypes.BROKER_WARRANTS_SELL_WILL_CANCEL,
        payload: {
            value
        }
    };
}

function stockContractChanged(value, titles) {
    return {
        type: actionTypes.BROKER_WARRANTS_SELL_STOCK_CONTRACT_CHANGED,
        payload: {
            value,
            titles
        }
    };
}

function validityDateChanged(value) {
    return {
        type: actionTypes.BROKER_WARRANTS_SELL_VALIDITY_DATE_CHANGED,
        payload: {
            value
        }
    };
}

function setSellPrice(sellPrice) {
    return {
        type: actionTypes.BROKER_WARRANTS_SELL_SET_SELL_PRICE,
        payload: {
            sellPrice
        }
    };
}

function limitPriceChanged(value, sellPrice) {
    return {
        type: actionTypes.BROKER_WARRANTS_SELL_LIMIT_PRICE_CHANGED,
        payload: {
            value,
            sellPrice
        }
    };
}

function titleQuantityChanged(value) {
    return {
        type: actionTypes.BROKER_WARRANTS_SELL_TITLE_QUANTITY_CHANGED,
        payload: {
            value
        }
    };
}

function validateUIStep(step) {
    return {
        type: actionTypes.BROKER_WARRANTS_SELL_VALIDATE_STEP,
        payload: {
            step
        }
    };
}

function validateWithAPISuccess(response) {
    return {
        type: actionTypes.BROKER_WARRANTS_SELL_VALIDATE_SUCCESS,
        payload: {
            data: response
        }
    };
}

function validateWithAPIFailure(response) {
    return {
        type: actionTypes.BROKER_WARRANTS_SELL_VALIDATE_FAILURE,
        payload: {
            data: response
        }
    };
}

function validateWithAPIRequest() {
    return {
        type: actionTypes.BROKER_WARRANTS_SELL_VALIDATE_REQUEST
    };
}

function signaturePatternSuccess(token) {
    return {
        type: actionTypes.BROKER_WARRANTS_SELL_SIGNATURE_SUCCESS,
        payload: {
            token
        }
    };
}

function confirmWarrantsSellSuccess(response) {
    return {
        type: actionTypes.BROKER_WARRANTS_SELL_CONFIRM_SUCCESS,
        payload: {
            data: response
        }
    };
}

function confirmWarrantsSellFailure(response) {
    return {
        type: actionTypes.BROKER_WARRANTS_SELL_CONFIRM_FAILURE,
        payload: {
            data: response
        }
    };
}

const resetLeaglConfirmationMail = () => ({
    type: actionTypes.BROKER_WARRANTS_SELL_LEGAL_MAIL_RESET
});

const LeaglConfirmationMailToClientSuccess = () => ({
    type: actionTypes.BROKER_WARRANTS_SELL_LEGAL_MAIL_SENT_SUCCESS
});

const LeaglConfirmationMailToClientRequest = () => ({
    type: actionTypes.BROKER_WARRANTS_SELL_LEGAL_MAIL_SENT_REQUEST
});

const LeaglConfirmationMailToClientFailure = (error) => ({
    type: actionTypes.BROKER_WARRANTS_SELL_LEGAL_MAIL_SENT_FAILURE,
    payload: {
        error
    }
});

const sendLeaglConfirmationMail = (inputData) => (dispatch, getState) => {
    const immBrokerProductFile = getState().brokerProductFile;
    const marketName = immBrokerProductFile.get('marketName') || "";
    const costYield = getState().brokerWarrantsSell.get('sellWarrantsTransactionCostObjectId');
    const communicationServiceInput = {
        "channel": CONNECTION_CHANNEL_INTRANET,
        "email": inputData.clientEmail,
        "sendOrder": "Yes",
        "saveDocumentation": "no",
        "productKID": "",
        "contract": "",
        "marketingReport": "",
        "infoCcs": "",
        "costYield": !!costYield ? costYield : null,
        "clientAlias": "",
        "isin": immBrokerProductFile.get('isinCode'),
        "isinDescribe": immBrokerProductFile.get('companyName'),
        "orderType": BROKER_ORDER_TYPE_SELL,
        "productType": BROKER_PRODUCT_TYPE_WARRANTS,
        "idOrder": "",
        "holders": "",
        "ccc": "",
        "ccv": "",
        "market": marketName,
        "sharesNumber": "",
        "orderCondition": "",
        "sharesAmount": "",
        "termValidity": "",
        "conditionPrize": "",
        "currency": "",
        "mifidWarningText": "",
        "dateTime": ""
    };

    const requestData = {
        query: communicationServiceInput
    };

    dispatch(LeaglConfirmationMailToClientRequest())
    return APIPost(dispatch, apiURLBuilder.getURL('communication'), requestData)
        .then(() => dispatch(LeaglConfirmationMailToClientSuccess()))

        .catch(error => dispatch(LeaglConfirmationMailToClientFailure(error)))
}

function getValidationData(getState) {
    const validationData = {
        descripcionRestriccion: BROKER_STOCKS_BUY_NO_RESTRICTION,
        tipoNegociacion: '0',
        tipoRestriccion: '0'
    };

    const orderTypes = {};

    orderTypes[BROKER_ORDER_TYPE_FOR_THE_BEST] = {
        code: FOR_THE_BEST_CODE,
        orderDescription: BROKER_ORDER_TYPE_FOR_THE_BEST_DESCRIPTION
    };
    orderTypes[BROKER_ORDER_TYPE_LIMITED] = {
        code: LIMITED_CODE,
        orderDescription: BROKER_ORDER_TYPE_LIMITED_DESCRIPTION
    };
    orderTypes[BROKER_ORDER_TYPE_TO_MARKET] = {
        code: TO_MARKET_CODE,
        orderDescription: BROKER_ORDER_TYPE_TO_MARKET_DESCRIPTION
    };

    const operationFirstStep = getState()['brokerWarrantsSell'].getIn(['steps', FIRST_STEP]);
    const orderType = operationFirstStep.get('orderTypeOption');
    //const validityDate = operationFirstStep.get('validityDate');
    const titleQuantity = operationFirstStep.get('titleQuantity');

    validationData['importeAprximado'] = {
        divisa: EURO_TEXT,
        importe: 0
    };

    if (orderType === BROKER_ORDER_TYPE_LIMITED) {
        validationData['importeLimitada'] = {
            divisa: EURO_TEXT,
            numeroimportevalores: operationFirstStep.get('orderTypeValue')
        };
    } else {
        validationData['importeLimitada'] = {
            divisa: EURO_TEXT,
            numeroimportevalores: 1
        };
    }
    validationData['numTitulos'] = titleQuantity;
    validationData['tipoOrden'] = orderTypes['limited'].code;
    validationData['descripcionOrden'] = orderTypes['limited'].orderDescription;
    validationData['plazoValidez'] = ''; // @todo Review it validityDate.format(DATE_FORMAT_API);

    return validationData;
}

function getCodes() {
    const pathName = window.location.pathname;
    const paramRegex = /(?:[^\/\n]|\/\/)+/g;
    const params = pathName.match(paramRegex);
    const emisionCode = params[params.length - 2];
    const valueCode = params[params.length - 1];

    return {
        emisionCode,
        valueCode
    };
}

function warrantsSellFinish(response) {
    return {
        type: actionTypes.BROKER_WARRANTS_SELL_FINISH,
        payload: {
            data: get(response, 'timestamp', '')
        }
    }
}

function warrantSellDocumentStorageRequest(){
    return {
        type: actionTypes.BROKER_WARRANTS_SELL_LEGAL_DOCUMENT_STORE_REQUEST
    }
}

function warrantSellDocumentStorageSuccess() {
    return {
        type: actionTypes.BROKER_WARRANTS_SELL_LEGAL_DOCUMENT_STORE_SUCCESS
    };
}

function warrantSellDocumentStorageError() {
    return {
        type: actionTypes.BROKER_WARRANTS_SELL_LEGAL_DOCUMENT_STORE_ERROR
    };
}

const generateMiFIDDisclaimers = (immBrokerConvenienceMiFIDTest) => {
    const immUSPersonDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'usPersonDisclaimers']);
    const immDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'disclaimers']);
    const immAllDisclaimers = Immutable.fromJS([]).merge(immUSPersonDisclaimers).merge(immDisclaimers);

    return immAllDisclaimers.map(immDisclaimer => immDisclaimer.get('description')).join(' | ');
};


const getHolders = (contract, interveners) => {
    let holderNames = [];
    if (interveners.size > 0) {
        const holders = interveners.filter((intervener) => {
            return intervener.get('tipoIntervencion').trim() === INTERVENER_TYPE_PROPIETARIO
        });
        holderNames = holders.map(holder => {
            return holder.get('nomInterviniente').trim()
        });
    } else {
        const holder = contract.get('walletTitular');
        holderNames.push(holder)
    }
    return holderNames;
}

const storeDocument = (response) => (dispatch, getState) => {

    const immProfile = getState().profile;
    const immBrokerWarrantsSell = getState().brokerWarrantsSell;
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const dataValidation = getValidationData(getState);
    const selectedOption = immBrokerWarrantsSell.getIn(['steps', FIRST_STEP, 'stocksContractSelectedValue']);
    const contract = getState().brokerStocksContract.find(contract => {
        return contract.get('walletNumber') === selectedOption;
    });
    const controlDigit = contract.get('controlDigit');
    const productNumber = contract.get('productNumber');
    const walletNumber = contract.get('walletNumber');
    const securityAccount = `${CHARGE_ACCOUNT_PREFIX}${controlDigit}${productNumber}${walletNumber}`;
    const marketName = getState().brokerProductFile.get('warrant').get('marketplace').trim();
    const emittedDateTime = momentTz(parseInt(get(response, 'timestamp', ''), 10)).tz("Europe/Madrid");
    const interveners = getState().brokerInterveners.get('list');
    const holderNames = getHolders(contract, interveners);
    const costYieldObjectId = immBrokerWarrantsSell.get('sellWarrantsTransactionCostObjectId');
    const isin = getState().brokerProductFile.get('isinCode');
    const limitPrice = immBrokerWarrantsSell.getIn(['steps', FIRST_STEP, 'orderTypeValue']);
    const exAnteData = immFlagBasedFeatures.get(WARRANTS_SELL_SHOW_COST) && !!immBrokerWarrantsSell.get('exAnteData')
        ? translateExantCostKey(immBrokerWarrantsSell.get('exAnteData').toJS(), 'brokerWarrantsSell')
        : null;
    const estimatedAmount =
        immFlagBasedFeatures.get(WARRANTS_SELL_SHOW_COST) &&
        immBrokerWarrantsSell.get('estimatedBaseAmount')
        ? immBrokerWarrantsSell.getIn(['estimatedBaseAmount', 'amount']) : "";
    const communicationServiceInput = {
        "email":PersonalDataHelper.getEmail(immProfile),
        "productKID": "",
        "contract": "",
        "marketingReport": "",
        "infoCcv": "",
        "costYield": !!costYieldObjectId ? costYieldObjectId : null,
        "sendOrder": "No",
        "clientAlias": immProfile.get('nombreCliente'),
        "isin": isin,
        "isinDescribe": getState().brokerProductFile.get('companyName'),
        "idOrder" :  get(response, 'numeroOrden', ''),
        "channel" : CONNECTION_CHANNEL_INTERNET,
        "orderType" : BROKER_ORDER_TYPE_SELL,
        "productType" : BROKER_PRODUCT_TYPE_WARRANTS,
        "holders" : holderNames.join(','),
        "ccv" : securityAccount,
        "idContract": securityAccount,
        "ccc": get(response, ['datosCuentaAsociada', 'codIban', 'codbban'], '').trim(),
        "market" : marketName,
        "sharesNumber": "" + dataValidation.numTitulos,
        "orderCondition": dataValidation.descripcionOrden,
        "sharesAmount" : estimatedAmount,
        "termValidity": dataValidation.plazoValidez,
        "conditionPrize": "" + limitPrice,
        "currency":  get(response, ['datosCuentaAsociada', 'saldoCuentaAsociada', 'divisa'], ''),
        "mifidWarningText": generateMiFIDDisclaimers(getState().brokerConvenienceMiFIDTest) ,
        "dateTime" : emittedDateTime.format(DATE_FORMAT_WITH_DASHES_DATETIME),
        "exAnteCostsList": exAnteData,
    };

    const requestData = {
        query: communicationServiceInput
    };

    dispatch(warrantSellDocumentStorageRequest());
    return APIPost(dispatch, apiURLBuilder.getURL('communication'), requestData).then(
        function () {
            dispatch(warrantSellDocumentStorageSuccess());
        },
        function () {
            dispatch(warrantSellDocumentStorageError());
        }
    );
}


const confirmWarrantsSell = (dataToken, history) => (dispatch, getState) => {
    const immWarrantsSellStep1 = getState().brokerWarrantsSell.getIn(['steps', FIRST_STEP]);
    const confirmationData = getState().brokerWarrantsSell.get('confirmationData');
    const executionData = confirmationData.datosEjecucion;
    const selectedOption = immWarrantsSellStep1.get('stocksContractSelectedValue');
    const contract = getState().brokerStocksContract.find(contract => {
        return contract.get('contactNumber') === selectedOption;
    });
    const codes = getCodes();
    const immBrokerProductFile = getState().brokerProductFile;
    const isinCode = immBrokerProductFile.get('isinCode');
    const micCode = immBrokerProductFile.get('micCode');
    const shares = immWarrantsSellStep1.get('titleQuantity');
    const isSpain = isinCode.substr(0, 2).toLowerCase() === 'es';
    const codigoDisclaimer = getState().brokerMiFIDProducts.getIn(['products', BROKER_CONVENIENCE_MIFID_TEST_WARRANTS_ID, 'codigoDisclaimer']);
    const immBrokerLegalDocumentation = getState().brokerLegalDocumentation;
    const uuid = immBrokerLegalDocumentation.get('uuid');

    const data = {
        contratoValores: {
            numerodecontrato: contract.get('walletNumber'),
            producto: contract.get('productNumber')
        },
        dataToken: dataToken,
        datosEjecucion: {
            codigoGrupoSector: executionData.codigoGrupoSector,
            codigoOrganismoEjecucion: executionData.codigoOrganismoEjecucion,
            codigoValorJuntSind: executionData.codigoValorJuntSind,
            codvalorSib: executionData.codvalorSib,
            indicadorCompensacion: executionData.indicadorCompensacion,
            indicadorContingencia: executionData.indicadorContingencia,
            indicadorEnvioRecepcion: executionData.indicadorEnvioRecepcion,
            nominalTitulo: {
                divisa: executionData.nominalTitulo.divisa,
                importe: executionData.nominalTitulo.importe
            },
            tipoCotizacion: executionData.tipoCotizacion,
            tipoMercado: executionData.tipoMercado,
            tipoOperacion: 'V',
            titulosNominalMinEjec: 0,
            tratamientoEmision: executionData.tratamientoEmision
        },
        datosEmision: {
            codEmision: codes.emisionCode,
            codMercado: confirmationData.codMercado,
            codValor: codes.valueCode
        },
        datosValidacion: getValidationData(getState),
        convenienceTest: codigoDisclaimer,
        productIsin: isinCode,
        productType: BROKER_CATEGORY_WARRANT,
        shares: shares,
        unitPrice: immBrokerProductFile.getIn(['productValue', 'amount']),
        productManager: immBrokerProductFile.get('manager'),
        micCode: micCode,
        initQuantity: shares,
        disclaimers: {
            disclaimer_1: "",
            disclaimer_2: "",
            disclaimer_3: "",
            disclaimer_4: "",
            disclaimer_5: ""
        },
        convenientRegistry: false,
        evaluateRegistry: false,
        marketTargetRegistry: false,
        necessaryConvenienceTestNote: 0,
        necessaryTargetMarketNote: "",
        testConveniencyResult: 0,
        documentationId: uuid
    };

    if (isSpain) {
        data.datosEjecucion['codigoBolsa'] = '1';
    }

    const requestData = {
        query: data,
        header: {
            version: 2
        }
    };

    return APIPost(dispatch, apiURLBuilder.getURL('confirmStocksBuySell'), requestData).then(
        function(response) {
            dispatch(storeDocument(response));
            dispatch(confirmWarrantsSellSuccess(response));
            dispatch(warrantsSellFinish(response));
            dispatch(outdateGlobalPosition());
            dispatch(outdateMyInvestments());
        },
        function(response) {
            dispatch(confirmWarrantsSellFailure(response));
            dispatch(brokerStocksOperationFailure(response, history));
        }
    );
};

const getInterveners = () => (dispatch, getState) => {
    const operationFirstStep = getState().brokerWarrantsSell.getIn(['steps', FIRST_STEP]);
    const selectedOption = operationFirstStep.get('stocksContractSelectedValue');
    const immBrokerStocksContract = getState().brokerStocksContract;
    const immContract = immBrokerStocksContract.find((contract) => {
                            return contract.get('contactNumber') === selectedOption;
                    });

    if (immContract) {
        const wallet = Immutable.fromJS({
            accountNumber: immContract.get('walletNumber'),
            product:  immContract.get('productNumber')
        })
        dispatch(brokerIntervenerActions.getIndexes(wallet));
    }
}

const validateWithAPI = (history) => (dispatch, getState) => {
    const immWarrantsSellStep1 = getState().brokerWarrantsSell.getIn(['steps', FIRST_STEP]);

    const selectedOption = immWarrantsSellStep1.get("stocksContractSelectedValue");
    const contract = getState().brokerStocksContract.find(contract => {
         return contract.get('contactNumber') === selectedOption;
    });

    const contractNumber = contract.get('walletNumber');
    const codes = getCodes();
    const controlDigitWallet = getState().brokerStocksContract.find(
        wallet => wallet.get('walletNumber') === contractNumber
    );

    const requestData = {
        codEmision: codes.emisionCode,
        codValor: codes.valueCode,
        contratoValores: {
            numerodecontrato: contractNumber,
            producto: contract.get('productNumber')
        },
        datosValidacion: getValidationData(getState),
        digitoControl: controlDigitWallet ? controlDigitWallet.get('controlDigit') : '',
        tipoOperacion: 'V'
    };

    dispatch(validateWithAPIRequest());
    return APIPost(dispatch, apiURLBuilder.getURL('sellStocks'), { query: requestData }).then(
        function(response) {
            dispatch(validateWithAPISuccess(response));
            dispatch(getInterveners());
        },
        function(response) {
            dispatch(validateWithAPIFailure(response));
            const errorKey = get(response, ['body', 'error'], '');
            dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
        }
    );
};

const onValidSignaturePattern = (dispatch, getState, dataToken, history) => {
    dispatch(signaturePatternSuccess(dataToken));
    dispatch(confirmWarrantsSell(dataToken, history));
};

const requestSignaturePatternValidation = (history) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        dispatch(onValidSignaturePattern(dispatch, getState, dataToken, history))
    }
    signaturePatternActions.validateAndExecute(dispatch, getState, callback)
};


const finish = (history) => dispatch => {
    dispatch(requestSignaturePatternValidation(history));
};

const validateStep = (step, history) => (dispatch, getState) => {
    dispatch(validateUIStep(step));

    switch (step) {
        case WIZARD_FIRST_STEP:
            const firstStepValid = getState().brokerWarrantsSell.getIn([
                'steps',
                FIRST_STEP,
                'valid'
            ]);
            const firstStepLoading = getState().brokerWarrantsSell.getIn([
                'steps',
                FIRST_STEP,
                'loading'
            ]);

            if (firstStepValid && !firstStepLoading) {
                dispatch(validateWithAPI(history));
            }

             break;
        case WIZARD_SECOND_STEP:
            const secondStepValid = getState().brokerWarrantsSell.getIn([
                'steps',
                SECOND_STEP,
                'valid'
            ]);
            const secondStepLoading = getState().brokerWarrantsSell.getIn([
                'steps',
                SECOND_STEP,
                'loading'
            ]);

            if (secondStepValid && !secondStepLoading) {
                dispatch(finish(history));
            }

             break;
    }
};

const changeReadChecked = checked => ({
    type: actionTypes.BROKER_WARRANTS_SELL_SUBSCRIPTION_CHANGE_READCHECKED,
    payload: {
        checked
    }
});

const fetchSellWarrantsCostRequest = () => ({
    type: actionTypes.BROKER_WARRANTS_SELL_LEGAL_DOCUMENT_COST_FETCH,
    payload: {}
});

const fetchSellwarrantsCostSuccess = (response) => ({
    type: actionTypes.BROKER_WARRANTS_SELL_LEGAL_DOCUMENT_COST_SUCCESS,
    payload: {response}
});

const fetchSellWarrantsCostError = (error) => ({
    type: actionTypes.BROKER_WARRANTS_SELL_LEGAL_DOCUMENT_COST_ERROR,
    payload: {error}
});

const getDocumentContentAPI = (response, mifidErrorDatePassed, history) => (dispatch) => {
    const data = {
        query: {
            objectId: response.objectId
        }

    }

    return APIGet(dispatch, apiURLBuilder.getURL('getDocumentContent'), data).then(response => {
        if(response && !!response.content) {
            const result = {
                objectId: data.query.objectId,
                content: response.content
            };
            dispatch(fetchSellwarrantsCostSuccess(result));
        } else {
            if (mifidErrorDatePassed) {
                dispatch(errorActions.show("brokerAPIErrors-errorPrimaryMessage", true, history));
            }
        }
    },
    (error) => {
        if (mifidErrorDatePassed) {
            dispatch(fetchSellWarrantsCostError(error));
            const errorKey = get(error, ["body", "error"], "");
            dispatch(errorActions.show("brokerAPIErrors-" + errorKey, true, history));
        }
    })
}

const fetchSellWarrantsTransactionCost = (fundIsin, history) =>(dispatch, getState) => {
    const immAccessKey = getState().accessKeyChange;
    const lastAccess = immAccessKey.getIn(['cmcContract', 'lastAccess']);
    const mifidErrorDatePassed = mifidErrorHelper.nationalIdDateValidation(lastAccess)
    dispatch(fetchSellWarrantsCostRequest());
    const data = {
        "documentType": BROKER_DOCUMENT_TYPE,
        "isin": fundIsin,
        "orderType": BROKER_ORDER_TYPE_SELL
    };
    const requestData = {
        query: data
    }
    return APIPost(dispatch, apiURLBuilder.getURL('getProductCost'), requestData).then(
        (response) => {
            if (response && response.objectId) {
                dispatch(getDocumentContentAPI(response, mifidErrorDatePassed, history));
            } else {
                if (mifidErrorDatePassed) {
                    dispatch(fetchSellWarrantsCostError(response));
                }
            }
        },
        (error) => {
            if (mifidErrorDatePassed) {
                dispatch(fetchSellWarrantsCostError(error));
            }
        }
    );
}

function getExAnteDataSuccess(response) {
    return {
        type: actionTypes.BROKER_WARRANTS_SELL_EX_ANTE_SUCCESS,
        payload: {
            data: response
        }
    };
}

function getExAnteDataFailure() {
    return {
        type: actionTypes.BROKER_WARRANTS_SELL_EX_ANTE_FAILURE,
    };
}

function getExAnteDataFetching() {
    return {
        type: actionTypes.BROKER_WARRANTS_SELL_EX_ANTE_FETCHING,
    };
}

const getExAnteData = (history) => (dispatch, getState) => {
    const immWarrantsSellStep1 = getState().brokerWarrantsSell.getIn(['steps', FIRST_STEP]);
    const immBrokerProductFile = getState().brokerProductFile;
    const selectedOption = immWarrantsSellStep1.get('stocksContractSelectedValue');
    const contract = getState().brokerStocksContract.find(contract => {
        return contract.get('contactNumber') === selectedOption;
    });
    const contractNumber = contract.get('walletNumber');
    const isinCode = immBrokerProductFile.get('isinCode');
    const shares = immWarrantsSellStep1.get('titleQuantity');
    const orderTypeOption = immWarrantsSellStep1.get('orderTypeOption');
    const productCurrency = immBrokerProductFile.get('currency');
    let limitedPrice, orderType;
    switch (orderTypeOption) {
        case BROKER_ORDER_TYPE_TO_MARKET:
            limitedPrice = null;
            orderType = "MARKET";
            break;
        case BROKER_ORDER_TYPE_FOR_THE_BEST:
            limitedPrice = null;
            orderType = "BEST";
            break;
        case BROKER_ORDER_TYPE_LIMITED:
        default:
            limitedPrice = {
                amount: immWarrantsSellStep1.get("orderTypeValue"),
                currency: productCurrency,
            }
            orderType = "LIMITED";
        break;
    }
    const requestData = {
        channel: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
        contract: {
            number: contractNumber,
            product: contract.get('productNumber'),
        },
        instrumentType: 'WARRANT',
        isin: isinCode,
        limitedPrice: limitedPrice,
        market: immBrokerProductFile.get('micCode'),
        operationType: 'V',
        orderType: orderType,
        sharesAmount: null,
        sharesNumber: shares,
    };

    const data = {
        query: requestData
    }
    dispatch(getExAnteDataFetching());
    return APIPost(dispatch, apiURLBuilder.getURL('brokerGetExAnteCost'), data)
        .then(response => dispatch(getExAnteDataSuccess(response)))
        .catch(error => {
            const errorKey = get(error, ['body', 'error'], '');
            dispatch(getExAnteDataFailure());
            dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
        })
}

module.exports = {
    reset,
    setVisibleStep,
    setSellPrice,
    validateStep,
    setWillCancel,
    finish,
    stockContractChanged,
    validityDateChanged,
    titleQuantityChanged,
    limitPriceChanged,
    changeReadChecked,
    fetchSellWarrantsTransactionCost,
    sendLeaglConfirmationMail,
    resetLeaglConfirmationMail,
    getExAnteData
};
